import { useEffect, useState } from "react";
import { publicApi } from "./adminApi";
import { wines as fallbackWines } from "../data/site";

export function useWines() {
  const [list, setList] = useState(fallbackWines);
  useEffect(() => {
    publicApi.get("/wines")
      .then((r) => { if (r.data.wines?.length) setList(r.data.wines); })
      .catch(() => {});
  }, []);
  return list;
}

export const WINE_DETAIL_ROWS = [
  { key: "vintage", label: "Ročník" },
  { key: "sweetness", label: "Cukernatost" },
  { key: "category", label: "Kategorie" },
  { key: "alcohol", label: "Alkohol" },
  { key: "region", label: "Vinařská oblast" },
  { key: "volume", label: "Objem" },
];
